/** * @Author: liujiannan * @Date: 2020-09-22 13:26:11 * @Description 首页住院
*/
<template>
  <div class="home-inpatient">
    <Banners :list="bannerList" />
    <div
      v-for="(menus, index) in menuList"
      :key="index"
      class="home-inpatient-function-list"
    >
      <!-- <div class="home-inpatient-function-list-title">
        {{ menus.menuname }}
      </div> -->
      <div v-if="index === 0" class="home-inpatient-function-list-content">
        <div
          v-for="item in menus.child"
          :key="item.menuname"
          @click="routeTo(item)"
        >
          <img v-if="item.icon" v-lazy="item.icon" alt="" />
          <div>{{ item.menuname }}</div>
        </div>
      </div>
      <ModuleFunctions
        v-else
        :list="menus.child"
        :title="menus.menuname"
        @routeTo="routeTo"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Banners from "./components/Banners";
import ModuleFunctions from "./components/ModuleFunctions";

export default {
  components: {
    Banners,
    ModuleFunctions
  },
  data() {
    return {
      bannerList: [],
      menuList: []
    };
  },
  created() {
    this.initData();
  },
  methods: {
    ...mapActions("home", ["routeNavigate"]),
    routeTo(item) {
      this.routeNavigate(item);
    },
    initData() {
      this.$http
        .post(this.$api.HOME, {
          functionType: "2"
        })
        .then(res => {
          const { menuList, advimgList, hasBind } = res;
          if (hasBind === "0") {
            this.$router.push({
              name: "relative-phone"
            });
            return;
          }
          this.bannerList = advimgList;
          this.menuList = menuList;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.home-inpatient {
  &-banner {
    height: 7.5rem;
    margin-bottom: 1rem;
  }

  &-function-list {
    margin-top: 1rem;
    &-title {
      margin: 0.8rem;
      font-weight: 500;
      font-size: 19px;
      line-height: 2.2rem;
    }

    &-content {
      display: flex;
      flex-wrap: wrap;

      > div {
        width: 25%;
        padding: 0.25rem 0;
        font-size: 0.81rem;
        line-height: 1.5rem;
        text-align: center;
      }
      img {
        width: 2.5rem;
        height: 2.5rem;
      }
    }
  }
}
</style>
